<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">Branding & Logos</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row">
          <ItemCard v-for="branding in brandings" :key="branding.id" :item="branding" :nextLink="'download/branding/' + branding.id"></ItemCard>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import Branding from '@/models/Branding'
import ItemCard from '@/components/ItemCard'
export default {
  name: 'Brandings',
  components: {
    ItemCard
  },
  data () {
    return {
      brandings: null
    }
  },
  mounted () {
    this.fetchBrandings()
  },
  methods: {
    fetchBrandings () {
      this.brandings = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchBrandings')
        .then((result) => {
          result.data.brandings.forEach(branding => {
            this.brandings.push(new Branding(branding))
          })
          $('.overlay').addClass('d-none')
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/BrandingAndLogos.vue